import React, { useEffect, useState, useContext } from 'react'
import { Context } from '../../Context'
import { useParams } from 'react-router-dom'
import { GuacamoleService } from '../../services/Guacamole'
import { VirtualMachineService } from '../../services/VirtualMachine'
import RemoteClient from '../../components/RemoteClient'
import { Layout } from '../../components/Layout'
import { Message } from 'primereact/message'
import { FullScreenModal } from '../../components/FullScreeModal'

import './styles.scss'

export const RemoteResource = () => {
  const { id: virtualMachineId } = useParams()
  const [encryptedToken, setEncryptedToken] = useState('')
  const { isAuth: token } = useContext(Context)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [virtualMachineSelected, setVirtualMachineSelected] = useState([])
  /* const [messageConsole, setMessageConsole] = useState([]) */
  // const [isPowering, setIsPowering] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const TransformVirtualMachineRequest = (virtualMachineSelected) => {
    let connectionType
    switch (virtualMachineSelected.connection_type) {
      case 'R':
        connectionType = 'rdp'
        break
      case 'S':
        connectionType = 'ssh'
        break
      case 'V':
        connectionType = 'vnc'
        break
      case 'T':
        connectionType = 'telnet'
        break
      default:
        connectionType = 'ssh'
    }

    const virtualMachineTrasnformed = {
      secretKey: 'GvfTBBRdtoPqk4FzxcXrIPxqnRSz0MZH',
      tokenObject: {
        connection: {
          type: connectionType,
          settings: {
            hostname: virtualMachineSelected.ip,
            port: virtualMachineSelected.port,
            username: virtualMachineSelected.username,
            password: virtualMachineSelected.password,
            'enable-drive': true,
            'create-drive-path': true,
            security: 'any',
            'ignore-cert': true,
            'enable-wallpaper': false,
          },
        },
      },
    }

    return virtualMachineTrasnformed
  }

  const handleErrorMessage = (message) => {}

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const virtualMachineSelected = await VirtualMachineService.getById(virtualMachineId, token)
        setVirtualMachineSelected(virtualMachineSelected)

        if (virtualMachineSelected) {
          const WsUrlGenerated = await GuacamoleService.getEncryptToken(
            TransformVirtualMachineRequest(virtualMachineSelected),
            token
          )
          const encryptedToken = WsUrlGenerated.encryptedToken
          setEncryptedToken(encryptedToken)
        }
      } catch (e) {
        setError(e.message)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [virtualMachineId, token])

  return (
    <Layout>
      {isLoading ? (
        <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error}></Message>
      ) : (
        <div className="remote-resource">
          <button onClick={openModal}>Abrir Remote Client</button>
          <div className="resource-remote-container">
            <FullScreenModal isOpen={isModalOpen} onClose={closeModal}>
              <RemoteClient encryptedToken={encryptedToken} onErrorMessage={handleErrorMessage} />
            </FullScreenModal>
            <div className="machine-title ">
              {`${virtualMachineSelected.display_name} - ${virtualMachineSelected.ip}`}
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
